import { RPDF } from '../common/react-pdf';
import React from 'react';

interface Props {
  color: string;
  style?: any;
}

export const ColorCircle: React.FC<Props> = (props) => {
  return (
    <RPDF.Svg style={props.style} width="7" height="7" viewBox="0 0 7 7">
      <RPDF.Circle
        cx="3.5"
        cy="3.5"
        r="2.5"
        stroke={props.color}
        stroke-width="1"
        fill={props.color}
      />
    </RPDF.Svg>
  );
};
